const MonitoringProgram = () => {
  mapboxgl.accessToken = 'pk.eyJ1IjoiY2Nid3Fwb3J0YWwiLCJhIjoiY2plcmdqcnB2MDYzbTM0dW13aWp6cXhnbiJ9.wnHy3esIvSyv_MdNX_nwqw';
  const map = new mapboxgl.Map({
      container: 'monitoring-program-map',
      style: 'mapbox://styles/ccbwqportal/cjergk7j70hcb2smayrcmwv8o',
      zoom: 12,
      center: [-104.854032, 39.639983],
  });

  const nav = new mapboxgl.NavigationControl();
  map.addControl(nav, 'top-left');
};
